<template>
  <div class="hero-marquee">
    <div class="marquee-track">
      <template v-for="i in 5" :key="i">
        <div class="marquee-item"><span class="dot"></span> 欢迎使用 {{ siteConfig.sitename }} 二级域名分发</div>
        <div class="marquee-item"><span class="dot"></span> 系统版本：V{{ siteConfig.version }}</div>
        <div class="marquee-item"><span class="dot"></span> 数据更新时间：{{ stats.currentTime }}</div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { siteConfig, stats } from '../data/data.js'
</script>
